import { StyleSheet, View } from 'react-native';

import { CircleLoader, RectangleLoader } from '../../../../Components/Loader';
import themeStyle from '../../../../Theme/styles';

import { ids as arrowStyleIds, styles as arrowStyles } from './Arrow';
import { styles as paginationStyles } from './Pagination';

const ExclusiveBannerLoader = ({
  height,
  width,
}: {
  height: number;
  width: number;
}) => {
  return (
    <View style={themeStyle.pageVerticalSpacing}>
      <View
        dataSet={{ media: arrowStyleIds.arrowContainer }}
        style={arrowStyles.arrowContainer}
      >
        <CircleLoader size={34} />
        <CircleLoader size={34} />
      </View>
      <View style={[themeStyle.pageVerticalSpacing, { height, width }]}>
        <View style={styles.container}>
          <RectangleLoader height="100%" width="100%" />
        </View>
      </View>
      <View style={themeStyle.flexDirectionRowCenterCenter}>
        <CircleLoader size={11} style={paginationStyles.dot} />
        <CircleLoader size={11} style={paginationStyles.dot} />
        <CircleLoader size={11} style={paginationStyles.dot} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...themeStyle.flex1,
    borderRadius: 12,
    overflow: 'hidden',
  },
});

export default ExclusiveBannerLoader;
